export default __webpack_public_path__ + "static/media/cross-icon.621e09f3.png";